<div>
  <label class="d-flex align-items-end"><span>{{label}}</span> </label>
  <div class="position-relative">
    <label *ngIf="required" class="form-required text-danger fw-500">*</label> 
    <input [formControl]="control" [textMask]="mask" class="form-control input-validate" type="text" (focus)="focusIn.emit($event)" (blur)="focusOut.emit($event)" >
  </div>
  <div [style.height.px]="0">
      <app-msg-erro [control]="control"></app-msg-erro>
    </div>
</div>
